import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';

@Component({
    selector: 'app-admin-cars',
    templateUrl: './admin-cars.component.html',
    styleUrl: './admin-cars.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminCarsComponent {

  businessLine: CarBusinessLine = CarBusinessLine.BUY; 

}
